import api from '../api';

const deleteMoldura = async (idRede, nomeArquivo) => {
  if (!idRede || !nomeArquivo) {
    throw new Error('ID da rede e nome do arquivo são obrigatórios');
  }

  try {
    const apiUrl = process.env.REACT_APP_API_BASE_72;
    const response = await api.delete(`${apiUrl}`, {
      data: {
        id_rede: idRede,
        nome_arquivo: nomeArquivo
      }
    });
    
    return {
      success: true,
      message: 'Moldura excluída com sucesso',
      data: response.data
    };
  } catch (error) {
    console.error('Erro ao excluir moldura:', error);
    throw new Error(error.response?.data?.message || 'Erro ao excluir moldura');
  }
};

export default deleteMoldura; 